import React, { Component } from "react";
import { connect } from 'react-redux';
import Header from "../../header/Header";

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.session.isAuthenticated
  }
}

class ResourceLibrary extends Component {
  constructor(props) {
    super(props);
    this.layout = props.name;
  }

  render() {
    const childProps = {
      header: 'standard',
      headerTitle: 'View our useful resources'
    }
    return (
      <div className="row">
        <Header childProps={childProps} />
        <div className="Home">
          <div className="lander container">
            <h2>Useful shit</h2>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(ResourceLibrary);



// WEBPACK FOOTER //
// ./src/containers/pages/resources/ResourceLibrary.js